/**
 * AVBP Portal entry — rebuild (Sprint 1).
 * The old anonymous/PIN/client-session boot dance is retired with the
 * legacy UI; session restore now lives inside <AuthProvider> via
 * onAuthStateChanged. No pre-mount auth race to manage.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { initConsultLocalOptIn } from './features/consulting/lib/flags';

// Capture the consult-scheduling preview opt-in (`?consult=1`) on first load,
// before render, so a deep-link that lands on any route persists the opt-in
// regardless of where it lands (the router would otherwise drop the param on
// the first client-side navigation). Local + per-browser; no Firestore write.
initConsultLocalOptIn();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
